'use strict';

var _require = require('./entityProvider'),
    registerEntity = _require.registerEntity,
    registerEntitySchema = _require.registerEntitySchema;

var _require2 = require('./abstractPerson'),
    AbstractPerson = _require2.AbstractPerson;

var _require3 = require('./appRole'),
    AppRole = _require3.AppRole;

var _require4 = require('./appUser'),
    AppUser = _require4.AppUser;

var _require5 = require('./baseEntity'),
    BaseEntity = _require5.BaseEntity;

var _require6 = require('./dateiupload'),
    Dateiupload = _require6.Dateiupload;

var _require7 = require('./externeOrganisation'),
    ExterneOrganisation = _require7.ExterneOrganisation;

var _require8 = require('./foerderung'),
    Foerderung = _require8.Foerderung;

var _require9 = require('./forschungsbericht'),
    Forschungsbericht = _require9.Forschungsbericht;

var _require10 = require('./forschungsprojekt'),
    Forschungsprojekt = _require10.Forschungsprojekt;

var _require11 = require('./kooperation'),
    Kooperation = _require11.Kooperation;

var _require12 = require('./land'),
    Land = _require12.Land;

var _require13 = require('./mittelgeber'),
    Mittelgeber = _require13.Mittelgeber;

var _require14 = require('./nachwuchsfoerderung'),
    Nachwuchsfoerderung = _require14.Nachwuchsfoerderung;

var _require15 = require('./orgaIdent'),
    OrgaIdent = _require15.OrgaIdent;

var _require16 = require('./organisationseinheit'),
    Organisationseinheit = _require16.Organisationseinheit;

var _require17 = require('./patent'),
    Patent = _require17.Patent;

var _require18 = require('./patentanzahl'),
    Patentanzahl = _require18.Patentanzahl;

var _require19 = require('./person'),
    Person = _require19.Person;

var _require20 = require('./personIdent'),
    PersonIdent = _require20.PersonIdent;

var _require21 = require('./personIdentTyp'),
    PersonIdentTyp = _require21.PersonIdentTyp;

var _require22 = require('./preis'),
    Preis = _require22.Preis;

var _require23 = require('./preisBezeichnung'),
    PreisBezeichnung = _require23.PreisBezeichnung;

var _require24 = require('./projektleiter'),
    Projektleiter = _require24.Projektleiter;

var _require25 = require('./promotionsprogrammtyp'),
    Promotionsprogrammtyp = _require25.Promotionsprogrammtyp;

var _require26 = require('./pubIdent'),
    PubIdent = _require26.PubIdent;

var _require27 = require('./pubIdentTyp'),
    PubIdentTyp = _require27.PubIdentTyp;

var _require28 = require('./publikation'),
    Publikation = _require28.Publikation;

var _require29 = require('./publikationsupload'),
    Publikationsupload = _require29.Publikationsupload;

var _require30 = require('./sdg'),
    Sdg = _require30.Sdg;

var _require31 = require('./strukturiertesPromotionsprogramm'),
    StrukturiertesPromotionsprogramm = _require31.StrukturiertesPromotionsprogramm;

var _require32 = require('./veranstaltung'),
    Veranstaltung = _require32.Veranstaltung;

var _require33 = require('../schema'),
    ForschungsprojektSchema = _require33.ForschungsprojektSchema;

var _require34 = require('../schema'),
    KooperationSchema = _require34.KooperationSchema;

var _require35 = require('../schema'),
    OrganisationseinheitSchema = _require35.OrganisationseinheitSchema;

var _require36 = require('../schema'),
    PatentSchema = _require36.PatentSchema;

var _require37 = require('../schema'),
    ProjektleiterSchema = _require37.ProjektleiterSchema;

var _require38 = require('../schema'),
    VeranstaltungSchema = _require38.VeranstaltungSchema;

module.exports = {
  AbstractPerson: AbstractPerson,
  AppRole: AppRole,
  AppUser: AppUser,
  BaseEntity: BaseEntity,
  Dateiupload: Dateiupload,
  ExterneOrganisation: ExterneOrganisation,
  Foerderung: Foerderung,
  Forschungsbericht: Forschungsbericht,
  Forschungsprojekt: Forschungsprojekt,
  Kooperation: Kooperation,
  Land: Land,
  Mittelgeber: Mittelgeber,
  Nachwuchsfoerderung: Nachwuchsfoerderung,
  OrgaIdent: OrgaIdent,
  Organisationseinheit: Organisationseinheit,
  Patent: Patent,
  Patentanzahl: Patentanzahl,
  Person: Person,
  PersonIdent: PersonIdent,
  PersonIdentTyp: PersonIdentTyp,
  Preis: Preis,
  PreisBezeichnung: PreisBezeichnung,
  Projektleiter: Projektleiter,
  Promotionsprogrammtyp: Promotionsprogrammtyp,
  PubIdent: PubIdent,
  PubIdentTyp: PubIdentTyp,
  Publikation: Publikation,
  Publikationsupload: Publikationsupload,
  Sdg: Sdg,
  StrukturiertesPromotionsprogramm: StrukturiertesPromotionsprogramm,
  Veranstaltung: Veranstaltung
};

registerEntity('de.ul.fob.domain.AbstractPerson', AbstractPerson);
registerEntity('de.ul.fob.security.AppRole', AppRole);
registerEntity('de.ul.fob.security.AppUser', AppUser);
registerEntity('de.ul.fob.domain.Dateiupload', Dateiupload);
registerEntity('de.ul.fob.domain.ExterneOrganisation', ExterneOrganisation);
registerEntity('de.ul.fob.domain.Foerderung', Foerderung);
registerEntity('de.ul.fob.domain.Forschungsbericht', Forschungsbericht);
registerEntity('de.ul.fob.domain.Forschungsprojekt', Forschungsprojekt);
registerEntity('de.ul.fob.domain.Kooperation', Kooperation);
registerEntity('de.ul.fob.domain.Land', Land);
registerEntity('de.ul.fob.domain.Mittelgeber', Mittelgeber);
registerEntity('de.ul.fob.domain.Nachwuchsfoerderung', Nachwuchsfoerderung);
registerEntity('de.ul.fob.domain.OrgaIdent', OrgaIdent);
registerEntity('de.ul.fob.domain.Organisationseinheit', Organisationseinheit);
registerEntity('de.ul.fob.domain.Patent', Patent);
registerEntity('de.ul.fob.domain.Patentanzahl', Patentanzahl);
registerEntity('de.ul.fob.domain.Person', Person);
registerEntity('de.ul.fob.domain.PersonIdent', PersonIdent);
registerEntity('de.ul.fob.domain.PersonIdentTyp', PersonIdentTyp);
registerEntity('de.ul.fob.domain.Preis', Preis);
registerEntity('de.ul.fob.domain.PreisBezeichnung', PreisBezeichnung);
registerEntity('de.ul.fob.domain.Projektleiter', Projektleiter);
registerEntity('de.ul.fob.domain.Promotionsprogrammtyp', Promotionsprogrammtyp);
registerEntity('de.ul.fob.domain.PubIdent', PubIdent);
registerEntity('de.ul.fob.domain.PubIdentTyp', PubIdentTyp);
registerEntity('de.ul.fob.domain.Publikation', Publikation);
registerEntity('de.ul.fob.domain.Publikationsupload', Publikationsupload);
registerEntity('de.ul.fob.domain.Sdg', Sdg);
registerEntity('de.ul.fob.domain.StrukturiertesPromotionsprogramm', StrukturiertesPromotionsprogramm);
registerEntity('de.ul.fob.domain.Veranstaltung', Veranstaltung);

registerEntitySchema('de.ul.fob.domain.Forschungsprojekt', ForschungsprojektSchema);
registerEntitySchema('de.ul.fob.domain.Kooperation', KooperationSchema);
registerEntitySchema('de.ul.fob.domain.Organisationseinheit', OrganisationseinheitSchema);
registerEntitySchema('de.ul.fob.domain.Patent', PatentSchema);
registerEntitySchema('de.ul.fob.domain.Projektleiter', ProjektleiterSchema);
registerEntitySchema('de.ul.fob.domain.Veranstaltung', VeranstaltungSchema);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/index.js
// module id = 9fz+
// module chunks = 0